module.exports = __webpack_public_path__ + "images/182_1024.jpg";